import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import productsReducer from "./productsSlice";
import productDataReducer from "./productDataSlice";
import i18nReducer from "./i18nSlice";
import modalReducer from "./modalSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productsReducer,
    productData: productDataReducer,
    i18n: i18nReducer,
    modal: modalReducer,
  },
});

export default store;



